import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../../api/services";

export const fetchAccountCreate: any = createAsyncThunk(
  "AddAccount/fetchList",
  async (account: any) => {
    const response = await API.post(`/instagram_account`,account);
    return response.data;
  }
);

const initialState = {
    addAccount: {},
    };
    const addAccountSlice = createSlice({
        name: "AddAccount",
        initialState,
        reducers: {
            setaddAccount: (state, { payload }) => {
                state.addAccount = payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAccountCreate.pending, (state) => {
            // Handle pending state if needed
        });
        builder.addCase(fetchAccountCreate.fulfilled, (state, action) => {
            state.addAccount = action.payload;
        });
        builder.addCase(fetchAccountCreate.rejected, (state, action) => {
            // Handle rejected state if needed
        });
    },
    });
export const { setaddAccount} = addAccountSlice.actions;
export default addAccountSlice.reducer;
